import React from 'react';
interface CaseStudy {
  thumbnail: string;
  title: string;
  url: string;
}
export function CaseStudiesSection() {
  const caseStudies: CaseStudy[] = [{
    thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oKL2RUFhp6qkvbGFwdaDfu/pasted-image.png',
    title: 'From Chronic Pain to Pain Free - Defeating Osteoarthritis',
    url: 'https://youtu.be/226rmSgq68A?si=FvO8wygPjwdfeT8U'
  }, {
    thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gCHd6t3G7ECjTaZPKrk6a6/pasted-image.png',
    title: 'Complete Upgrade in Business & Life - Total Performance Enhancement',
    url: 'https://youtu.be/VxilMGM7uE8?si=WPp7FEr-gy8F1snb'
  }, {
    thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oJBi22my5QWSprp2dLrH7P/pasted-image.png',
    title: 'High Radial Nerve Palsy Reversed - From Wrist Drop to Full Recovery',
    url: 'https://youtu.be/DG-Tf01uqfk?si=4u2a-_FsTqzvzGa8'
  }, {
    thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gWrdoTVTtD8tnzKrhceBmG/pasted-image.png',
    title: 'How He Escaped Dialysis & Reversed Kidney Disease',
    url: 'https://youtu.be/yrF73YFikJI?si=r77xKstcDTM2PBdo'
  }, {
    thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sUYNQpBzsywUhjzha6Ud1E/pasted-image.png',
    title: 'Beating "Incurable" Autoimmune Disease - Reversing Rheumatoid Arthritis',
    url: 'https://youtu.be/VLAbfsKtAvo?si=0UdYOxyYJxdnf-SV'
  }, {
    thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2RDUn16cxVxDMPjfP6bCVd/pasted-image.png',
    title: 'Reversing Heart Failure - No Longer Needs Heart Transplant',
    url: 'https://youtu.be/bmLQYGeC960?si=cGt3AQfMjNz3nBNi'
  }, {
    thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3tJoDykHovRmH2SXskyd54/pasted-image.png',
    title: 'Defying Age: From Burnout to 15-Year Biological Age Reversal',
    url: 'https://youtu.be/YwEywZxMSgo?si=sxvzMNW78swQxJM8'
  }, {
    thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tA6F2wb81UfvKyHq7dYXrw/pasted-image.png',
    title: 'From Cognitive Decline to Mental Superhuman',
    url: 'https://youtu.be/bdFY2s3nbtM?si=ylMcP485F9gONF5x'
  }, {
    thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qZ4EpkZoX599qCEfq3gNVv/pasted-image.png',
    title: "How We're Reversing Alzheimer's Disease - The Breakthrough Approach",
    url: 'https://youtu.be/TEDmmZfPIa0?si=oPFcNi7vt43c2VuT'
  }];
  return <div className="w-full px-6 py-20 bg-gradient-to-b from-slate-900/50 to-slate-950" data-id="element-17">
      <div className="max-w-6xl mx-auto space-y-12" data-id="element-18">
        <div className="text-center space-y-4" data-id="element-19">
          <h2 className="text-4xl md:text-5xl font-bold text-white" style={{
          fontFamily: 'Oswald, sans-serif'
        }} data-id="element-20">
            Success Stories & Case Studies
          </h2>
          <p className="text-xl text-gray-300 font-light" data-id="element-21">
            Real transformations from real people
          </p>
        </div>
        <div className="space-y-6" data-id="element-22">
          {caseStudies.map((study, index) => <a key={index} href={study.url} target="_blank" rel="noopener noreferrer" className="flex flex-col sm:flex-row gap-6 bg-slate-900/50 border border-purple-500/20 rounded-lg p-6 hover:border-cyan-500/50 transition-all hover:shadow-lg hover:shadow-cyan-500/20 group" data-id="element-23">
              <div className="flex-shrink-0" data-id="element-24">
                <img src={study.thumbnail} alt={study.title} className="w-full sm:w-80 h-auto rounded-lg group-hover:scale-105 transition-transform" data-id="element-25" />
              </div>
              <div className="flex items-center" data-id="element-26">
                <h3 className="text-xl md:text-2xl font-bold text-white group-hover:text-cyan-400 transition-colors" style={{
              fontFamily: 'Oswald, sans-serif'
            }} data-id="element-27">
                  {study.title}
                </h3>
              </div>
            </a>)}
        </div>
        <div className="text-center space-y-6 pt-12 border-t border-purple-500/20" data-id="element-28">
          <h3 className="text-3xl md:text-4xl font-bold text-white" style={{
          fontFamily: 'Oswald, sans-serif'
        }} data-id="element-29">
            Ready to Start Your Transformation?
          </h3>
          <div className="flex justify-center" data-id="element-30">
            <a href="https://go.peptidescienceinstitute.com/mwm" className="px-8 py-4 bg-gradient-to-r from-purple-600 to-cyan-600 text-white font-semibold rounded-lg hover:from-purple-500 hover:to-cyan-500 transition-all shadow-lg shadow-purple-500/50" data-id="element-31">
              Book Your Meeting
            </a>
          </div>
        </div>
      </div>
    </div>;
}